export default "__VITE_ASSET__Cqs6v_JE__"